import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'

import MainMenuIcon from './MainMenuIcon'
import ExternalLink from 'src/components/ExternalLink'

// Styles
import menuStyles from 'src/components/Menu/menu.module.scss'

class MainMenuItem extends Component {
    static propTypes = {
        icon: PropTypes.object,
        iconActive: PropTypes.object,
        title: PropTypes.string,
        to: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({ pathname: PropTypes.string }),
        ]),
        externalLink: PropTypes.bool,
        isOpen: PropTypes.bool,
        isChild: PropTypes.bool,
        onClick: PropTypes.func,
        className: PropTypes.string,
        /** When the sidebar is collapsed, the menu items change rendering and style. */
        parentIsCollapsed: PropTypes.bool,
        subNavigation: PropTypes.bool,
        isActive: PropTypes.func,
        openNewTab: PropTypes.bool,
        disabled: PropTypes.bool,
    }

    hideDropdownMenu = e => {
        e.currentTarget.blur()
        // TODO find clean way to hide the dropdown in the collapse state.
    }

    renderDropdown() {
        const {
            icon,
            iconActive,
            title,
            children,
            isOpen,
            onClick,
            parentIsCollapsed,
            subNavigation = false,
        } = this.props

        return (
            <div
                className={cx(menuStyles.collapseWrapper, {
                    [menuStyles.collapseWrapperHover]:
                        parentIsCollapsed && !subNavigation,
                    [menuStyles.navigationMargin]: !subNavigation,
                    [menuStyles.subNavigationMargin]: subNavigation,
                    [menuStyles.isExpanded]: isOpen,
                })}
            >
                <button
                    className={cx(menuStyles.mainMenuItem, {
                        [menuStyles.menuOpen]: isOpen,
                        [menuStyles.subNavigationBtn]: subNavigation,
                    })}
                    onClick={onClick}
                >
                    <MainMenuIcon icon={icon} iconActive={iconActive} />
                    <span className={menuStyles.mainTitle}>{title}</span>
                    {parentIsCollapsed && (
                        <span className={menuStyles.collapsedMainMenuItem}>
                            {title}
                        </span>
                    )}
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={menuStyles.collapseIcon}
                    />
                </button>
                <div
                    className={cx(menuStyles.collapseChildren, {
                        [menuStyles.open]: isOpen,
                    })}
                >
                    {React.Children.map(children, item => {
                        if (!item) {
                            return null
                        }
                        return React.cloneElement(
                            item,
                            {
                                className: `${menuStyles.mainMenuChildItem} ${
                                    subNavigation && menuStyles.secondLevelChild
                                } ${
                                    parentIsCollapsed &&
                                    menuStyles.fontWeightCollapsed
                                }`,
                                isChild: true,
                            },
                            item.props.children
                        )
                    })}
                </div>
            </div>
        )
    }

    render() {
        const {
            icon,
            iconActive,
            title,
            to,
            externalLink,
            children,
            isChild = false,
            className,
            parentIsCollapsed,
            subNavigation = false,
            isActive,
            openNewTab = false,
            exact = false,
        } = this.props

        if (to) {
            // This is a link to another page
            return (
                <NavLink
                    activeClassName={menuStyles.active}
                    className={cx(className, menuStyles.mainMenuItem)}
                    to={to}
                    onClick={this.hideDropdownMenu}
                    isActive={isActive}
                    component={externalLink ? ExternalLink : undefined}
                    // Only bind openNewTab if the component is ExternalLink - otherwise it leaks to the DOM
                    // Ideally we'd just do this by passing a prop to the ExternalLink component directly
                    {...(externalLink ? { openNewTab: openNewTab } : {})}
                    exact={exact}
                >
                    <MainMenuIcon icon={icon} iconActive={iconActive} />
                    <span className={menuStyles.mainTitle}>{title}</span>
                    {parentIsCollapsed && !isChild && (
                        <span className={menuStyles.collapsedMainMenuItem}>
                            {title}
                        </span>
                    )}
                </NavLink>
            )
        }

        if (!parentIsCollapsed || !subNavigation) {
            // We don't have a link to a page
            // If our parent wasn't collapsed and we're not on the deepest level (L3), we're a dropdown
            return this.renderDropdown()
        }

        // This is the L3 / the deepest level of the menu, also render a navLink
        return (
            <div>
                {React.Children.map(children, child => {
                    if (!child) {
                        return null
                    }

                    return (
                        <NavLink
                            activeClassName={menuStyles.active}
                            className={cx(className, menuStyles.mainMenuItem)}
                            to={child.props.to}
                            onClick={this.hideDropdownMenu}
                            component={externalLink ? externalLink : undefined}
                            {...(externalLink
                                ? { openNewTab: openNewTab }
                                : {})}
                        >
                            <span className={menuStyles.mainTitle}>
                                {child.props.title}
                            </span>
                        </NavLink>
                    )
                })}
            </div>
        )
    }
}

export default MainMenuItem
